.icon {
  color: var(--dds-color-icon-link);
}
